// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DocumentExpert_grid-row-2__cwZxr {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 24px;
}

.DocumentExpert_vm-20__XJbTS {
  margin: 20px 0;
}

.DocumentExpert_divider-0__L6POH {
  width: 100%;
  height: 1px;
  background-color: #d0d7dd;
}

.DocumentExpert_rel__h-ula {
  position: relative;
}

.DocumentExpert_flex__v4pvX {
  display: flex;
}

.DocumentExpert_jcc__WPI8U {
  justify-content: center !important;
}

.DocumentExpert_editor__6CCyY {
  display: grid;
  grid-template-columns: 376px 1fr;
  column-gap: 24px;
}
.DocumentExpert_editor__docx__V-u59 {
  width: 100%;
  position: relative;
}
.DocumentExpert_editor__docx__V-u59 .DocumentExpert_border__ZIdGj {
  border-radius: 8px;
}
.DocumentExpert_editor__6CCyY .DocumentExpert_panelWrapper__nMXgW .DocumentExpert_gradingBlock__1\\+5Uh {
  width: 346px;
}
.DocumentExpert_editor__6CCyY .DocumentExpert_panelWrapper__nMXgW .DocumentExpert_gradingBlock__description__EoJEM {
  margin-top: 12px;
  line-height: 18px;
  padding: 12px 20px;
  background: linear-gradient(270deg, rgba(224, 241, 254, 0.3) 0%, rgba(212, 248, 239, 0.3) 49.63%, rgba(199, 247, 233, 0.3) 100%);
  border-radius: 8px;
}
.DocumentExpert_editor__6CCyY .DocumentExpert_panelWrapper__nMXgW .DocumentExpert_neuroAnalysis__SnCdI {
  display: flex;
  flex-direction: column;
  font-family: "SBSansText";
}
.DocumentExpert_editor__6CCyY .DocumentExpert_panelWrapper__nMXgW .DocumentExpert_neuroAnalysis__title__G7tGf {
  margin-top: 4px;
  font-weight: 600;
  font-size: 12px;
  line-height: 22px;
  color: #000000;
  text-transform: uppercase;
}
.DocumentExpert_editor__6CCyY .DocumentExpert_panelWrapper__nMXgW .DocumentExpert_neuroAnalysis__status__QjvAN {
  font-family: "SFProDisplay";
  margin-top: 12px;
  text-align: center;
  font-size: 12px;
  line-height: 18px;
  color: #333F48;
  width: max-content;
  padding: 0 4px;
  background: rgba(238, 80, 90, 0.5);
  border-radius: 4px;
}
.DocumentExpert_editor__6CCyY .DocumentExpert_panelWrapper__nMXgW .DocumentExpert_neuroAnalysis__status_true__nnQtX {
  background: rgba(48, 186, 154, 0.5);
}
.DocumentExpert_editor__6CCyY .DocumentExpert_panelWrapper__nMXgW .DocumentExpert_neuroAnalysis__detailed__2olrZ {
  margin-top: 20px;
  color: #00809C;
  cursor: pointer;
}
.DocumentExpert_editor__6CCyY .DocumentExpert_finalGrade__4tUVu {
  margin-top: 14px;
  width: min-content;
  background: linear-gradient(56.46deg, #A4EEDC -45.58%, #5BCAB5 19.1%, #6BAAE4 100%);
  border-radius: 8px;
  padding: 0 6px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  white-space: nowrap;
}

.DocumentExpert_saveExit__Umrch {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  cursor: pointer;
}
.DocumentExpert_saveExit__Umrch .DocumentExpert_arrow__k3Nro {
  transform: rotate(180deg);
  fill: darkgreen;
}
.DocumentExpert_saveExit__Umrch .DocumentExpert_saveExitText__emUkT {
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  color: rgb(0, 128, 156);
  margin-top: 6px;
}

.DocumentExpert_markupContainer__wFmuk {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.DocumentExpert_markupSection__ZNasJ {
  border-radius: 8px;
  background-color: rgb(248, 249, 250);
  padding: 20px;
}
.DocumentExpert_markupSection__ZNasJ .DocumentExpert_markupTitle__aMEDa {
  line-height: 26px;
  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 5px;
  min-height: 26px;
  display: block;
}
.DocumentExpert_markupSection__ZNasJ .DocumentExpert_markupText__3r0Y\\+ {
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 16px;
}
.DocumentExpert_markupSection__ZNasJ .DocumentExpert_markupTags__DNiBP {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
}
.DocumentExpert_markupSection__ZNasJ .DocumentExpert_markupTag__vxO5w {
  padding: 4px 12px;
  background-color: rgb(225, 229, 234);
  border-radius: 16px;
  white-space: nowrap;
}

.DocumentExpert_buttonOverlayTags__jj7-A {
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: left;
  display: flex;
  align-items: center;
  color: rgb(0, 128, 156);
  cursor: pointer;
}

.DocumentExpert_tooltip__ro7xz {
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/assets/helpers/grid.scss","webpack://./src/components/pages/document/DocumentExpert/DocumentExpert.module.scss","webpack://./src/assets/helpers/colors.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;ACAF;;ADIA;EACE,cAAA;ACDF;;ADKA;EACE,WAAA;EACA,WAAA;EACA,yBEVM;ADQR;;ADMA;EACE,kBAAA;ACHF;;ADMA;EACE,aAAA;ACHF;;ADMA;EACE,kCAAA;ACHF;;AAxBA;EACE,aAAA;EACA,gCAAA;EACA,gBAAA;AA2BF;AAxBE;EACE,WAAA;EACA,kBAAA;AA0BJ;AAxBI;EACE,kBAAA;AA0BN;AApBI;EACE,YAAA;AAsBN;AAhBM;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gIAAA;EACA,kBAAA;AAkBR;AAdI;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;AAgBN;AAdM;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cClBA;EDmBA,yBAAA;AAgBR;AAbM;EACE,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cC9BC;ED+BD,kBAAA;EACA,cAAA;EACA,kCAAA;EACA,kBAAA;AAeR;AAbQ;EACE,mCAAA;AAeV;AAXM;EACE,gBAAA;EACA,cC/BE;EDgCF,eAAA;AAaR;AARE;EACE,gBAAA;EACA,kBAAA;EACA,mFCxBY;EDyBZ,kBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;AAUJ;;AANA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AASF;AAPE;EACE,yBAAA;EAEE,eAAA;AAQN;AAJE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AAMJ;;AAFA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAKF;;AAFA;EACE,kBAAA;EACA,oCAAA;EACA,aAAA;AAKF;AAHE;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAKJ;AAFE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAIJ;AADE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;AAGJ;AAAE;EACE,iBAAA;EACA,oCAAA;EACA,mBAAA;EACA,mBAAA;AAEJ;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AACF","sourcesContent":["// grid\n.grid-row-2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap: 24px;\n}\n\n// paddings, margins\n.vm-20 {\n  margin: 20px 0;\n}\n\n// elements\n.divider-0 {\n  width: 100%;\n  height: 1px;\n  background-color: $gray5;\n}\n\n// helpers\n.rel {\n  position: relative;\n}\n\n.flex {\n  display: flex;\n}\n\n.jcc {\n  justify-content: center!important;\n}","@import '../../../../assets/helpers/index.scss';\n\n.editor {\n  display: grid;\n  grid-template-columns: 376px 1fr;\n  column-gap: 24px;\n\n\n  &__docx {\n    width: 100%;\n    position: relative;\n\n    .border {\n      border-radius: 8px;\n    }\n  }\n\n  .panelWrapper {\n\n    .gradingBlock {\n      width: 346px;\n\n      &__title {\n\n      }\n\n      &__description {\n        margin-top: 12px;\n        line-height: 18px;\n        padding: 12px 20px;\n        background: linear-gradient(270deg, rgba(224, 241, 254, 0.3) 0%, rgba(212, 248, 239, 0.3) 49.63%, rgba(199, 247, 233, 0.3) 100%);\n        border-radius: 8px;\n      }\n    }\n\n    .neuroAnalysis {\n      display: flex;\n      flex-direction: column;\n      font-family: 'SBSansText';\n\n      &__title {\n        margin-top: 4px;\n        font-weight: 600;\n        font-size: 12px;\n        line-height: 22px;\n        color: $black;\n        text-transform: uppercase;\n      }\n\n      &__status {\n        font-family: 'SFProDisplay';\n        margin-top: 12px;\n        text-align: center;\n        font-size: 12px;\n        line-height: 18px;\n        color: $black2;\n        width: max-content;\n        padding: 0 4px;\n        background: rgba(238, 80, 90, 0.5);\n        border-radius: 4px;\n\n        &_true {\n          background: rgba(48, 186, 154, 0.5);\n        }\n      }\n\n      &__detailed {\n        margin-top: 20px;\n        color: $prGreen;\n        cursor: pointer;\n      }\n    }\n  }\n\n  .finalGrade {\n    margin-top: 14px;\n    width: min-content;\n    background: $gradientLight;\n    border-radius: 8px;\n    padding: 0 6px;\n    display: flex;\n    flex-direction: column;\n    flex-wrap: nowrap;\n    white-space: nowrap;\n  }\n}\n\n.saveExit {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  align-items: center;\n  cursor: pointer;\n\n  .arrow {\n    transform: rotate(180deg);\n\n      fill: darkgreen;\n\n  }\n\n  .saveExitText {\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 22px;\n    letter-spacing: 0em;\n    text-align: left;\n    color: rgba(0, 128, 156, 1);\n    margin-top: 6px;\n  }\n}\n\n.markupContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.markupSection {\n  border-radius: 8px;\n  background-color: rgba(248, 249, 250, 1);\n  padding: 20px;\n\n  .markupTitle {\n    line-height: 26px;\n    letter-spacing: 0em;\n    text-align: left;\n    margin-bottom: 5px;\n    min-height: 26px;\n    display: block;\n  }\n\n  .markupText {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 22px;\n    letter-spacing: 0em;\n    text-align: left;\n    margin-bottom: 16px;\n  }\n\n  .markupTags {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .markupTag {\n    padding: 4px 12px;\n    background-color: rgba(225, 229, 234, 1);\n    border-radius: 16px;\n    white-space: nowrap;\n  }\n}\n\n.buttonOverlayTags {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: 0px;\n  text-align: left;\n  display: flex;\n  align-items: center;\n  color: rgba(0, 128, 156, 1);\n  cursor: pointer;\n}\n\n.tooltip {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 22px;\n  letter-spacing: 0em;\n  text-align: left;\n\n}","//  Color scheme\n$white: #ffffff;\n$whiteGray: #f2f4f7;\n$halfGray: #f5faff;\n$grayWhite: #e7e9eb;\n$gray2: #e9eaea;\n$gray5: #d0d7dd;\n$gray7: #d1d5df;\n$gray8: #f4f4f4;\n$gray13: #f8f9fa;\n$gray12: #e0e1e9;\n$gray9: #cbcdd0;\n$gray10: #E1E5EA;\n$gray11: #1F1F22;\n$shadowGray: #d5d5d6;\n$shadowGray2: rgba(25, 27, 35, 0.15);\n$gray3: #c4c4c4;\n$lightGray: #aab1ba;\n$gray4: #878b90;\n$gray6: #7d838a;\n$gray14: #F6F6F6;\n$grayAsphalt: #344045;\n$gray: #808185;\n$textGray: #000000;\n$black1: #0b1f33;\n$black2: #333F48;\n\n$black: #000000;\n\n$lightGreen: #a4eedc;\n$green3: #5dc8ba;\n$green: #21ba72;\n$green0: #30BA9A;\n$green0-0_5: rgba(48, 186, 154, 0.50);\n$green4: #62BDCA;\n$darkGreen: #209f6d;\n$green2: #21a19a;\n$prGreen: #00809C;\n$lightBlue: #d8ebfe;\n$blue: #1358bf;\n$red: #ee505a;\n$red0_5: rgba(238, 80, 90, 0.5);\n$red1: #EC1B28;\n$beige: rgba(255, 205, 156, 0.6);\n$yellow: #FFE5CD;\n\n// gradients\n$defaultGradient: linear-gradient(\n                56.46deg,\n                #a4eedc -45.58%,\n                #5bcab5 19.1%,\n                #6baae4 100%\n);\n$gradientLight: linear-gradient(56.46deg, #A4EEDC -45.58%, #5BCAB5 19.1%, #6BAAE4 100%);\n$gradient2: linear-gradient(\n                270deg,\n                rgba(224, 241, 254, 0.4) 0%,\n                rgba(212, 248, 239, 0.4) 49.63%,\n                rgba(199, 247, 233, 0.4) 100%\n);\n$gradient3: linear-gradient(225deg, #eef181 0%, #92dd90 51.47%, #4de9cb 100%);\n$gradient4: linear-gradient(\n                270deg,\n                rgba(224, 241, 254, 0.3) 0%,\n                rgba(212, 248, 239, 0.3) 49.63%,\n                rgba(199, 247, 233, 0.3) 100%\n);\n$gradient5: linear-gradient(270deg, #E0F1FE 0%, #D4F8EF 49.63%, #C7F7E9 100%);\n$gradient6: linear-gradient(270deg, #E0F1FE 0%, #D4F8EF 49.63%, #C7F7E9 100%);\n$gradientPlaceholder: linear-gradient(90deg, rgba(255,255,255,0) -10%, rgba(255,255,255,1) 50%);\n$gradientPlaceholderDisabled: linear-gradient(90deg, rgb(163 224 219 / 18%) -10%, rgb(233 234 234) 50%);\n$boxShadowModal: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n$gradientDanger: linear-gradient(94.6deg, #FEA4A4 0.09%, #EE6767 100.09%);\n$gradientOrange: linear-gradient(91.58deg, #FFB973 0.03%, #FFA244 100.03%);\n$mainPageBackground: linear-gradient(180deg, rgba(255, 255, 255, 0) 61.86%, rgba(255, 255, 255, 0.8) 100%), radial-gradient(10.51% 41.68% at 32.4% 13.32%, rgba(33, 186, 114, 0.36) 0%, rgba(33, 186, 114, 0) 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */\n, radial-gradient(33.57% 117.61% at 63.33% -9.67%, rgba(90, 177, 255, 0.24) 0%, rgba(0, 135, 205, 0.24) 0.01%, rgba(0, 135, 205, 0) 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */\n, radial-gradient(19.56% 68.52% at -4.53% 77.65%, rgba(255, 224, 102, 0.3) 0%, rgba(255, 224, 102, 0) 100%), linear-gradient(90deg, rgba(66, 227, 180, 0.34) 0%, rgba(107, 234, 199, 0.34) 49.98%, rgba(155, 208, 254, 0.34) 100%), #FFFFFF;\n//  color vars\n$borderOpacityColor: rgba(214, 214, 215, 0.5);\n$boxShadowColor: rgba(0, 0, 0, 0.08);\n$footerColor: #f8fefc;\n$nonActiveText: $gray9;\n\n$primary: $green;\n$main: $white;\n$scrollBg: $halfGray;\n$scroll: $gray7;\n$scrollHover: $shadowGray;\n$editorMenuHover: $halfGray;\n$border: $gray5;\n\n$mainText: $black;\n$headText: $textGray;\n$smallText: $gray6;\n$tableSmallText: $gray4;\n$blockTitle: $black1;\n$calendarGradient: $gradient5;\n$chartActiveBg: $gradient3;\n$nonActiveElement: $gray8;\n\n$secondaryColor: $lightGray;\n$borderColor: $grayWhite;\n$tooltipBorder: $gray12;\n$tooltipShadow: $shadowGray2;\n$danger: $red;\n$serviceDanger: $red1;\n$mainBtnDanger: $gradientDanger;\n$action: $prGreen;\n$bgAction: lighten($lightGreen, 15%);\n$inputBorderColor: $shadowGray;\n$selectBorderColor: $gray10;\n$documentButton: $gray2;\n$tagBackground: $whiteGray;\n$cardShadow: $boxShadowModal;\n$textSelected: $lightBlue;\n$menuHover: $gradient5;\n$blockBg: $gray13;\n$toggleBg: $gradientLight;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid-row-2": `DocumentExpert_grid-row-2__cwZxr`,
	"vm-20": `DocumentExpert_vm-20__XJbTS`,
	"divider-0": `DocumentExpert_divider-0__L6POH`,
	"rel": `DocumentExpert_rel__h-ula`,
	"flex": `DocumentExpert_flex__v4pvX`,
	"jcc": `DocumentExpert_jcc__WPI8U`,
	"editor": `DocumentExpert_editor__6CCyY`,
	"editor__docx": `DocumentExpert_editor__docx__V-u59`,
	"border": `DocumentExpert_border__ZIdGj`,
	"panelWrapper": `DocumentExpert_panelWrapper__nMXgW`,
	"gradingBlock": `DocumentExpert_gradingBlock__1+5Uh`,
	"gradingBlock__description": `DocumentExpert_gradingBlock__description__EoJEM`,
	"neuroAnalysis": `DocumentExpert_neuroAnalysis__SnCdI`,
	"neuroAnalysis__title": `DocumentExpert_neuroAnalysis__title__G7tGf`,
	"neuroAnalysis__status": `DocumentExpert_neuroAnalysis__status__QjvAN`,
	"neuroAnalysis__status_true": `DocumentExpert_neuroAnalysis__status_true__nnQtX`,
	"neuroAnalysis__detailed": `DocumentExpert_neuroAnalysis__detailed__2olrZ`,
	"finalGrade": `DocumentExpert_finalGrade__4tUVu`,
	"saveExit": `DocumentExpert_saveExit__Umrch`,
	"arrow": `DocumentExpert_arrow__k3Nro`,
	"saveExitText": `DocumentExpert_saveExitText__emUkT`,
	"markupContainer": `DocumentExpert_markupContainer__wFmuk`,
	"markupSection": `DocumentExpert_markupSection__ZNasJ`,
	"markupTitle": `DocumentExpert_markupTitle__aMEDa`,
	"markupText": `DocumentExpert_markupText__3r0Y+`,
	"markupTags": `DocumentExpert_markupTags__DNiBP`,
	"markupTag": `DocumentExpert_markupTag__vxO5w`,
	"buttonOverlayTags": `DocumentExpert_buttonOverlayTags__jj7-A`,
	"tooltip": `DocumentExpert_tooltip__ro7xz`
};
export default ___CSS_LOADER_EXPORT___;
